import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { provideIcons } from "@ng-icons/core";
import { lucideChevronDown } from "@ng-icons/lucide";
import { SidebarComponent } from "../../molecules/sidebar/sidebar.component";
import { AuthFlowService } from "../../../services/auth-flow/auth-flow.service";

@Component({
  selector: "keus-storybook",
  imports: [RouterModule, SidebarComponent, CommonModule],
  viewProviders: [provideIcons({ lucideChevronDown })],
  templateUrl: "./storybook.component.html",
  styleUrl: "./storybook.component.css",
})
export class StorybookComponent {
  /** Injected service for handling auth flow. */
  private readonly _authFlowService: AuthFlowService = inject(AuthFlowService);

  /** Whether the user has completed auth flow */
  public readonly isCompleted = this._authFlowService.isCompleted;
}
